import { EmployeesNotificationsConsentModal } from './EmployeesNotificationsConsentModal'

export { EmployeesNotificationsConsentModal }
